import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import type { ArticleDetail, ArticleSummary, PageOf } from '@/lib/api/models';
import { unwrap } from '@/lib/api/request';

export function useArticles(params: { limit?: number; offset?: number } = {}) {
  const { limit = 12, offset = 0 } = params;
  return useQuery<PageOf<ArticleSummary>>({
    queryKey: ['articles', { limit, offset }],
    queryFn: () => unwrap(api.GET('/articles', { params: { query: { limit, offset } } })),
  });
}

export function useArticle(slug: string) {
  return useQuery<ArticleDetail>({
    queryKey: ['article', slug],
    queryFn: () => unwrap(api.GET('/articles/{slug}', { params: { path: { slug } } })),
  });
}
